import { Logger } from '@frontend/logger';
import { useEffect } from 'react';

const GEO_PROMPT_FLAG_KEY = 'mobile-geolocation-prompted';

/**
 * Requests OS/browser geolocation once on first app launch.
 * Users manage enable/disable in device or browser settings afterwards.
 */
export const RequestGeolocationPermission = (props: { children: React.ReactNode }) => {
    useEffect(() => {
        if (typeof window === 'undefined' || typeof navigator === 'undefined' || !navigator.geolocation) {
            return;
        }

        try {
            if (window.localStorage.getItem(GEO_PROMPT_FLAG_KEY) === '1') {
                return;
            }
            window.localStorage.setItem(GEO_PROMPT_FLAG_KEY, '1');
        } catch {
            // localStorage may be unavailable; still attempt a one-shot prompt this session
        }

        navigator.geolocation.getCurrentPosition(
            () => {
                Logger.log('Geolocation permission granted.');
            },
            (error) => {
                Logger.log('Geolocation permission not granted:', error.message);
            },
            { enableHighAccuracy: false, timeout: 15_000, maximumAge: 60_000 }
        );
    }, []);

    return props.children;
};

export default RequestGeolocationPermission;
